module.exports = __webpack_public_path__ + "static/media/appbar_background.dc0f4db6.png";